<div class="search-shell">
    <header class="hero-banner">
        <!-- Decorative constellation art from the client design boilerplate
             (7-14-26). Static markup — the fade mask lives in the SCSS. -->
        <svg class="hero-art" viewBox="0 0 1336 340" fill="none" preserveAspectRatio="none" aria-hidden="true">
            <path d="M 520 60 C 560 42, 610 52, 640 38 C 660 28, 690 34, 700 48 C 712 64, 745 58, 770 50 C 800 40, 840 46, 858 62 C 872 74, 905 70, 930 62 C 965 50, 1010 56, 1040 74 C 1062 88, 1100 84, 1130 92 C 1170 102, 1205 122, 1215 148 C 1223 170, 1200 186, 1165 190 C 1140 193, 1128 208, 1140 222 C 1152 236, 1136 252, 1105 254 C 1080 256, 1058 246, 1040 252 C 1015 260, 1000 248, 992 234 C 982 218, 950 220, 935 210 C 918 198, 890 202, 872 192 C 850 180, 820 186, 796 178 C 770 168, 748 174, 730 164 C 708 152, 676 158, 660 146 C 640 132, 606 138, 588 126 C 566 112, 540 116, 528 100 C 518 86, 498 70, 520 60 Z" fill="#dff1fa" opacity="0.09"></path>
            <path d="M 700 240 C 730 226, 775 230, 800 244 C 822 256, 856 252, 878 262 C 902 273, 912 292, 902 310 C 893 326, 868 330, 848 342 C 830 353, 812 372, 790 376 C 766 380, 750 366, 744 348 C 738 330, 718 322, 706 306 C 692 288, 676 252, 700 240 Z" fill="#dff1fa" opacity="0.085"></path>
            <path d="M 1190 268 C 1205 260, 1225 264, 1230 276 C 1235 288, 1220 296, 1204 293 C 1189 290, 1178 274, 1190 268 Z" fill="#dff1fa" opacity="0.075"></path>
            <path d="M 1252 300 C 1262 294, 1276 298, 1278 306 C 1280 314, 1268 320, 1257 317 C 1247 314, 1243 305, 1252 300 Z" fill="#dff1fa" opacity="0.065"></path>
            <path d="M 596 200 C 610 194, 628 198, 630 208 C 632 218, 618 224, 604 220 C 592 216, 586 205, 596 200 Z" fill="#dff1fa" opacity="0.07"></path>
            <path d="M 960 180 L 430 -60" stroke="#9cc6de" stroke-width="1.5" opacity="0.45"></path>
            <path d="M 960 180 L 330 120" stroke="#b3dcef" stroke-width="1" opacity="0.4"></path>
            <path d="M 960 180 L 400 340" stroke="#9cc6de" stroke-width="1.5" opacity="0.45"></path>
            <path d="M 960 180 L 700 420" stroke="#c4e2ef" stroke-width="1" opacity="0.4"></path>
            <path d="M 960 180 L 1120 420" stroke="#9cc6de" stroke-width="1.5" opacity="0.45"></path>
            <path d="M 960 180 L 1336 300" stroke="#b3dcef" stroke-width="1" opacity="0.42"></path>
            <path d="M 960 180 L 1336 150" stroke="#c4e2ef" stroke-width="1.5" opacity="0.5"></path>
            <path d="M 960 180 L 1250 -60" stroke="#b3dcef" stroke-width="1" opacity="0.4"></path>
            <path d="M 960 180 L 890 -60" stroke="#c4e2ef" stroke-width="1" opacity="0.4"></path>
            <ellipse cx="960" cy="180" rx="90" ry="126" stroke="#c4e2ef" stroke-width="1" opacity="0.5" stroke-dasharray="2 6" stroke-linecap="round"></ellipse>
            <ellipse cx="960" cy="180" rx="210" ry="294" stroke="#9cc6de" stroke-width="1" opacity="0.32" stroke-dasharray="2 8" stroke-linecap="round"></ellipse>
            <circle cx="620" cy="26" r="3" fill="#c4e2ef" opacity="0.45"></circle>
            <circle cx="790" cy="103" r="3" fill="#c4e2ef" opacity="0.6"></circle>
            <circle cx="560" cy="295" r="3" fill="#b3dcef" opacity="0.45"></circle>
            <circle cx="760" cy="252" r="3" fill="#b3dcef" opacity="0.6"></circle>
            <circle cx="1240" cy="215" r="3" fill="#c4e2ef" opacity="0.5"></circle>
            <circle cx="1090" cy="196" r="3.5" fill="#dff1fa" opacity="0.7"></circle>
            <circle cx="1150" cy="-10" r="3" fill="#b3dcef" opacity="0.4"></circle>
            <circle cx="1035" cy="105" r="3.5" fill="#dff1fa" opacity="0.7"></circle>
            <ellipse cx="960" cy="180" rx="6" ry="8.4" fill="#dff1fa" opacity="0.95"></ellipse>
            <ellipse cx="960" cy="180" rx="13" ry="18.2" stroke="#dff1fa" stroke-width="1" opacity="0.55"></ellipse>
        </svg>
        <h1>Science Talent Network</h1>
        <p class="lede">Find qualified Earth and space science talent beyond the usual applicant pool.</p>
        <p class="sub">Upload a job description to identify candidates based on verified scholarly work, with clear fit and gap analysis.</p>
    </header>

    <form class="search-card" (ngSubmit)="Submit()">
        <div class="input-frame">
            <svg class="search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" aria-hidden="true">
                <circle cx="11" cy="11" r="7"></circle>
                <line x1="16.5" y1="16.5" x2="21" y2="21"></line>
            </svg>
            <textarea
                name="inputText"
                rows="3"
                class="combined-input"
                [(ngModel)]="inputText"
                placeholder="Paste a job description or describe the candidate you are looking for.&#10;Example: PhD hydrologist in the St. Louis area with Python and GIS experience."></textarea>
        </div>

        <maps-upload-drop-zone
            class="hidden-zone"
            [disabled]="isSearching"
            (extractedUploadIdsChange)="OnExtractedUploadIdsChange($event)"
            (busyChange)="OnUploadBusyChange($event)"
            (fileCountChange)="OnFileCountChange($event)"></maps-upload-drop-zone>

        <div class="search-actions">
            <button
                type="button"
                class="upload-btn"
                (click)="TriggerUpload()"
                [disabled]="isSearching || uploadsFull"
                [attr.title]="uploadsFull ? 'Maximum of ' + maxFiles + ' files reached — remove one to add another' : null">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <line x1="12" y1="16" x2="12" y2="4"></line>
                    <polyline points="6 10 12 4 18 10"></polyline>
                    <line x1="4" y1="20" x2="20" y2="20"></line>
                </svg>
                {{ uploadsFull ? 'File limit reached (' + maxFiles + ')' : 'Upload a Job Description' }}
            </button>
            <small class="hint" [class.error]="!isInputValid && inputText.length > 0">
                <ng-container *ngIf="uploadFileCount > 0">
                    {{ uploadFileCount }} / {{ maxFiles }} files{{ uploadsFull ? ' (max)' : '' }} ·
                </ng-container>
                <ng-container *ngIf="isBelowMinimum; else charCount">
                    Enter at least 50 characters ({{ inputText.trim().length }} so far)
                </ng-container>
                <ng-template #charCount>{{ inputText.trim().length }} / 50,000 chars</ng-template>
            </small>
            <button
                type="button"
                class="clear-btn"
                *ngIf="inputText.length > 0 || rawResults.length > 0"
                [disabled]="isSearching"
                (click)="ClearSearch()">
                Clear Search
            </button>
            <button type="submit" class="search-btn" [disabled]="!canSearch">
                {{ isSearching ? 'Searching…' : 'Search' }}
            </button>
        </div>

        <maps-recent-search-chips
            [searches]="recentSearches"
            [disabled]="isSearching || isRestoring"
            (restoreClicked)="RestoreSavedSearch($event)"></maps-recent-search-chips>

        <p *ngIf="errorMessage" class="error">{{ errorMessage }}</p>

        <div class="panel-footer" *ngIf="searchId && !isSearching">
            <maps-filter-bar
                [filters]="filters"
                [sortKey]="sortKey"
                [results]="rawResults"
                [positionState]="positionState"
                (filtersChange)="OnFiltersChange($event)"
                (sortKeyChange)="OnSortChange($event)">
                <!-- Export moved to the bulk action bar (STN mockup): it acts
                     on a selection, so it appears with one. -->
                <button
                    *ngIf="canReapply"
                    type="button"
                    class="adjust-weighting-btn"
                    data-testid="adjust-weighting"
                    [attr.aria-expanded]="weightingOpen"
                    (click)="OpenWeightingDrawer()">
                    <svg viewBox="0 0 16 16" aria-hidden="true">
                        <path d="M2 4.5h8M12.5 4.5H14M2 11.5h3M7.5 11.5H14" stroke="currentColor"
                              stroke-width="1.5" stroke-linecap="round" />
                        <circle cx="10.5" cy="4.5" r="1.8" fill="none" stroke="currentColor" stroke-width="1.5" />
                        <circle cx="5.5" cy="11.5" r="1.8" fill="none" stroke="currentColor" stroke-width="1.5" />
                    </svg>
                    Adjust weighting
                    <span class="count" *ngIf="weightingBadgeCount > 0">{{ weightingBadgeCount }}</span>
                </button>
            </maps-filter-bar>
        </div>
    </form>

    <section class="empty-state" *ngIf="showEmptyState">
        <span class="empty-icon" aria-hidden="true">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                 stroke-linecap="round">
                <circle cx="11" cy="11" r="7"></circle>
                <line x1="16.5" y1="16.5" x2="21" y2="21"></line>
            </svg>
        </span>
        <h2>Upload a document or search to see candidates</h2>
        <p>Results will appear here. You can refine with filters and sorting after results load.</p>
    </section>

    <!-- Fresh-search loading state: skeleton grid + the staged progress message. -->
    <section class="loading" *ngIf="isSearching">
        <p class="loading-meta" aria-live="polite">
            <span class="spinner" aria-hidden="true"></span> {{ searchProgressMessage }}
        </p>
        <div class="skeleton-grid" aria-hidden="true">
            <div class="skeleton-card" *ngFor="let s of skeletonSlots">
                <div class="sk-head">
                    <div class="sk-bar sk-title"></div>
                    <div class="sk-bar sk-sub"></div>
                </div>
                <div class="sk-body">
                    <div class="sk-block"></div>
                    <div class="sk-bar sk-line-1"></div>
                    <div class="sk-bar sk-line-2"></div>
                    <div class="sk-btn-row">
                        <div class="sk-btn dark"></div>
                        <div class="sk-btn"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Stays mounted after any completed search (even zero results) so the
         qualification panel survives a rerun that excludes every candidate —
         otherwise the recruiter is stranded on the initial empty state with no
         way to loosen their required qualifications. Hidden only before the
         first search, during a fresh search, and after a failed search. -->
    <section *ngIf="searchId && !isSearching" class="results">
        <div class="results-meta">
            <span class="meta" *ngIf="resultMetaMessage">{{ resultMetaMessage }}</span>
            <span class="generating" *ngIf="isGeneratingSummaries" aria-live="polite">
                <span class="spinner" aria-hidden="true"></span> Generating summaries…
            </span>
            <!-- Select All / Clear toolbar (6-8 client meeting). The cap matches
                 defaultResultCount under the hood (see SelectAllVisible()), but
                 the label stays clean — admins tune the number in /admin/configuration. -->
            <div class="bulk-select" *ngIf="hasResults">
                <button
                    type="button"
                    class="bulk-link"
                    (click)="SelectAllVisible()"
                    [disabled]="isAllVisibleSelected">
                    Select all
                </button>
                <button
                    type="button"
                    class="bulk-link quiet"
                    (click)="ClearSelection()"
                    [disabled]="selectedCount === 0">
                    Clear selection
                </button>
            </div>
            <span class="selected" *ngIf="selectedCount > 0">{{ selectedCount }} selected</span>
        </div>

        <div class="refine-stack" *ngIf="trace && canSeePipelinePanel">
            <p class="refine-eyebrow">Refine your results</p>

            <!-- Read-only pipeline + agent-I/O panel (technical drill-down). Gate is
                 admin OR the live "showPipelinePanelToAll" setting (admin-toggleable
                 from /admin/configuration), so admins can expose it to partner users
                 as a trust marker per the 6-8 client meeting. -->
            <section class="brief-panel" #briefPanel *ngIf="trace && canSeePipelinePanel">
                <button
                    type="button"
                    class="brief-toggle"
                    (click)="ToggleBrief()"
                    [attr.aria-expanded]="briefOpen">
                    <span class="icon-tile" aria-hidden="true">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="5" cy="12" r="2.5"></circle>
                            <circle cx="19" cy="5" r="2.5"></circle>
                            <circle cx="19" cy="19" r="2.5"></circle>
                            <line x1="7.3" y1="11" x2="16.7" y2="6"></line>
                            <line x1="7.3" y1="13" x2="16.7" y2="18"></line>
                        </svg>
                    </span>
                    <span class="brief-titles">
                        <span class="brief-title">
                            Matching methodology
                            <span class="chevron" [class.open]="briefOpen" aria-hidden="true">&#9656;</span>
                        </span>
                        <span class="brief-caption">See how the agent parsed your description and scored each candidate.</span>
                    </span>
                </button>
                <ol class="brief-body flow" *ngIf="briefOpen && trace as t">
                    <ng-container *ngIf="brief as b">
                        <!-- 1. Intake / brief agent -->
                        <li class="flow-step">
                            <div class="step-head">
                                <span class="step-num">1</span>
                                <h4>Intake agent · decompose the request</h4>
                            </div>
                            <p class="step-desc">AI. Turns the raw input into a structured brief — research queries for the vector search + parsed requirements.</p>

                            <button class="io-toggle" (click)="ToggleSection('brief.in')" [attr.aria-expanded]="IsSectionOpen('brief.in')">
                                <span class="caret" [class.open]="IsSectionOpen('brief.in')">&#9656;</span> Input — what it sees
                            </button>
                            <pre class="io-pre" *ngIf="IsSectionOpen('brief.in')">{{ t.briefInput }}</pre>

                            <button class="io-toggle" (click)="ToggleSection('brief.out')" [attr.aria-expanded]="IsSectionOpen('brief.out')">
                                <span class="caret" [class.open]="IsSectionOpen('brief.out')">&#9656;</span> Output — the brief
                            </button>
                            <div class="io-body" *ngIf="IsSectionOpen('brief.out')">
                                <div class="brief-group" *ngIf="b.researchTopics.length > 0">
                                    <h5>Research topics</h5>
                                    <div class="chips"><span class="chip" *ngFor="let x of b.researchTopics">{{ x }}</span></div>
                                </div>
                                <div class="brief-group" *ngIf="b.retrievalQueries.length > 0">
                                    <h5>Vector queries</h5>
                                    <ul class="query-list"><li *ngFor="let q of b.retrievalQueries">{{ q }}</li></ul>
                                </div>
                                <!-- Always rendered (client 7-29): a third of real searches ran with
                                     no level signal and nobody could see it — the empty state is the
                                     audit hook for extraction failures. Since 8-10 the level is a GATE:
                                     confirmed above-band candidates are excluded (client 8-06). -->
                                <div class="brief-group">
                                    <h5>Target level <span class="note">— candidates confirmed above this level are excluded; more junior candidates may appear, flagged as a stretch</span></h5>
                                    <div class="chips">
                                        <span class="chip" *ngIf="b.minYearsExperience != null">&ge;{{ b.minYearsExperience }} years experience</span>
                                        <span class="chip" *ngFor="let s of b.targetCareerStages ?? []">{{ StageLabel(s) }}</span>
                                        <span class="chip avoid" *ngIf="b.minYearsExperience == null && (b.targetCareerStages ?? []).length === 0">No level signal extracted</span>
                                    </div>
                                </div>
                                <!-- The qualification set (required + tiered preferred) is the editable
                                     artifact this stage produces; "Update results" overwrites it and the
                                     rest of the pipeline runs off it. -->
                                <div class="brief-group" *ngIf="requiredQualifications.length > 0">
                                    <h5>Required <span class="note">— candidates missing these are excluded</span></h5>
                                    <div class="chips"><span class="chip req" *ngFor="let q of requiredQualifications">{{ q.text }}</span></div>
                                </div>
                                <div class="brief-group" *ngFor="let tier of preferredTierGroups">
                                    <h5>{{ tier.label }}</h5>
                                    <div class="chips"><span class="chip pref" *ngFor="let q of tier.items">{{ q.text }}</span></div>
                                </div>
                                <div class="brief-group" *ngIf="b.exclusions.length > 0">
                                    <h5>Avoid</h5>
                                    <div class="chips"><span class="chip avoid" *ngFor="let r of b.exclusions">{{ r }}</span></div>
                                </div>
                                <!-- Eligibility items are deliberately never scored/Required
                                     (anti-discrimination design); this line makes the gate that
                                     enforces them visible (7-27 C-4.3). -->
                                <div class="brief-group" *ngIf="EligibilityConstraintChips.length > 0">
                                    <h5>Eligibility constraints <span class="note">— applied as location gate</span></h5>
                                    <div class="chips"><span class="chip req" *ngFor="let e of EligibilityConstraintChips">{{ e }}</span></div>
                                </div>
                                <div class="brief-group" *ngIf="b.unverifiable.length > 0">
                                    <h5>Unverifiable <span class="note">— excluded from ranking</span></h5>
                                    <div class="chips"><span class="chip verify" *ngFor="let r of b.unverifiable">{{ r }}</span></div>
                                </div>
                                <div class="brief-group" *ngIf="b.seeksInterdisciplinarity">
                                    <h5>Interdisciplinarity <span class="note">— spread boost enabled</span></h5>
                                    <div class="chips"><span class="chip">Posting explicitly seeks cross-field breadth</span></div>
                                </div>
                            </div>
                        </li>

                        <!-- 2. Vector retrieval -->
                        <li class="flow-step">
                            <div class="step-head">
                                <span class="step-num">2</span>
                                <h4>Vector retrieval · publication similarity</h4>
                            </div>
                            <p class="step-desc">Vector search over publications only. In = the brief's queries; out = {{ pipelineStats.total }} contributors + cosine. No structured fields, no identity.</p>
                            <div class="step-desc verified-note" *ngIf="t.verifiedFilters && t.verifiedFilters.length > 0">
                                Verified-first: {{ t.verifiedUniverse | number }} of {{ t.poolTotal | number }} members positively satisfy
                                <span class="chips"><span class="chip req" *ngFor="let f of t.verifiedFilters">{{ f }}</span></span>
                                based on structured profile data — retrieved as a priority slice that leads the results; everyone else fills in by similarity. Nobody is excluded for missing data.
                            </div>

                            <button class="io-toggle" (click)="ToggleSection('retrieval.in')" [attr.aria-expanded]="IsSectionOpen('retrieval.in')">
                                <span class="caret" [class.open]="IsSectionOpen('retrieval.in')">&#9656;</span> Input — queries sent
                            </button>
                            <div class="io-body" *ngIf="IsSectionOpen('retrieval.in')">
                                <pre class="io-pre">Publication-vector similarity · multi-query union</pre>
                                <ul class="query-list"><li *ngFor="let q of b.retrievalQueries">{{ q }}</li></ul>
                            </div>

                            <button class="io-toggle" (click)="ToggleSection('retrieval.out')" [attr.aria-expanded]="IsSectionOpen('retrieval.out')">
                                <span class="caret" [class.open]="IsSectionOpen('retrieval.out')">&#9656;</span> Output — pool + cosine
                            </button>
                            <div class="io-body" *ngIf="IsSectionOpen('retrieval.out')">
                                <table class="io-table">
                                    <tr><th>Candidate</th><th>cosine</th></tr>
                                    <tr *ngFor="let c of t.candidates"><td>{{ c.name }}</td><td>{{ c.cosine | number: '1.3-3' }}</td></tr>
                                </table>
                            </div>
                        </li>

                        <!-- 3. Corpus match / hydration -->
                        <li class="flow-step">
                            <div class="step-head">
                                <span class="step-num">3</span>
                                <h4>Corpus match · hydration</h4>
                            </div>
                            <p class="step-desc">Deterministic join: vector <code>sourceId</code> → <code>MAPS.Person.AGUPersonID</code>. {{ pipelineStats.hydrated }}/{{ pipelineStats.total }} matched to full profiles; {{ pipelineStats.withPublication }} got a real AGU publication. Unmatched show fewer fields — never fabricated.</p>

                            <button class="io-toggle" (click)="ToggleSection('match.out')" [attr.aria-expanded]="IsSectionOpen('match.out')">
                                <span class="caret" [class.open]="IsSectionOpen('match.out')">&#9656;</span> Per-candidate match
                            </button>
                            <div class="io-body" *ngIf="IsSectionOpen('match.out')">
                                <table class="io-table">
                                    <tr><th>Candidate</th><th>AGU profile</th></tr>
                                    <tr *ngFor="let c of t.candidates">
                                        <td>{{ c.name }}</td>
                                        <td>{{ c.matched ? '✓ matched' : '— publication only' }}</td>
                                    </tr>
                                </table>
                            </div>
                        </li>

                        <!-- 4. Re-rank · holistic fit (provider-aware) -->
                        <li class="flow-step">
                            <div class="step-head">
                                <span class="step-num">4</span>
                                <h4>Rank · relevance &amp; qualifications</h4>
                            </div>
                            <p class="step-desc">Eligibility gates run first, before any ranking: candidates who positively conflict with a stated location/visa requirement, sit confirmed ABOVE the role's seniority level, or fall confirmed below an explicit degree requirement are removed and listed below — each removal is backfilled from a deeper retrieval pool, so exclusions never shrink the result count. Unknown data never excludes. Then default runs re-rank the eligible roster via the configured provider, blended with publication cosine. When a qualification weighting is applied, each candidate is instead assessed against the qualifications above: anyone positively assessed as missing a REQUIRED qualification is excluded from the results, and the rest are ranked by their tier-weighted preferred score blended with cosine; tier from that score. Final ordering groups by match tier first, then by the blend within each tier — and on level-targeted searches, candidates whose stage could not be determined are listed after all confirmed level-appropriate candidates.</p>
                            <div class="step-desc verified-note" *ngIf="b.seeksInterdisciplinarity">
                                Interdisciplinarity boost applied: this posting explicitly seeks cross-field breadth, so each candidate's publication-topic spread (as a population percentile) was blended into the ordering at a 15% weight. Candidates with fewer than 5 distinct publications score neutral — never penalized. Match tiers are unaffected.
                            </div>

                            <button class="io-toggle" (click)="ToggleSection('rerank.out')" [attr.aria-expanded]="IsSectionOpen('rerank.out')">
                                <span class="caret" [class.open]="IsSectionOpen('rerank.out')">&#9656;</span> Output — score + reason
                            </button>
                            <div class="io-body" *ngIf="IsSectionOpen('rerank.out')">
                                <table class="io-table">
                                    <tr><th>Candidate</th><th>rel.</th><th>reason</th></tr>
                                    <tr *ngFor="let c of t.candidates">
                                        <td>{{ c.name }}</td>
                                        <td>{{ c.relevance == null ? '—' : (c.relevance | number: '1.2-2') }}</td>
                                        <td>{{ c.reason || '—' }}</td>
                                    </tr>
                                </table>
                            </div>

                            <ng-container *ngIf="FitFlaggedTraceCandidates.length > 0">
                                <button class="io-toggle" (click)="ToggleSection('rerank.flags')" [attr.aria-expanded]="IsSectionOpen('rerank.flags')">
                                    <span class="caret" [class.open]="IsSectionOpen('rerank.flags')">&#9656;</span> Soft constraint flags ({{ FitFlaggedTraceCandidates.length }})
                                </button>
                                <div class="io-body" *ngIf="IsSectionOpen('rerank.flags')">
                                    <table class="io-table">
                                        <tr><th>Candidate</th><th>flags (ordering nudge only — tier unchanged, nobody removed)</th></tr>
                                        <tr *ngFor="let c of FitFlaggedTraceCandidates">
                                            <td>{{ c.name }}</td>
                                            <td>{{ c.fitFlags.join('; ') }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="t.qualificationExcluded && t.qualificationExcluded.length > 0">
                                <button class="io-toggle" (click)="ToggleSection('rerank.qexcl')" [attr.aria-expanded]="IsSectionOpen('rerank.qexcl')">
                                    <span class="caret" [class.open]="IsSectionOpen('rerank.qexcl')">&#9656;</span> Excluded — missing a required qualification ({{ t.qualificationExcluded.length }})
                                </button>
                                <div class="io-body" *ngIf="IsSectionOpen('rerank.qexcl')">
                                    <table class="io-table">
                                        <tr><th>Candidate</th><th>why removed</th></tr>
                                        <tr *ngFor="let d of t.qualificationExcluded">
                                            <td>{{ d.name }}</td>
                                            <td>{{ d.reasons.join('; ') }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="t.disqualified.length">
                                <button class="io-toggle" (click)="ToggleSection('rerank.dq')" [attr.aria-expanded]="IsSectionOpen('rerank.dq')">
                                    <span class="caret" [class.open]="IsSectionOpen('rerank.dq')">&#9656;</span> Disqualified — removed for stated requirements ({{ t.disqualified.length }})
                                </button>
                                <div class="io-body" *ngIf="IsSectionOpen('rerank.dq')">
                                    <table class="io-table">
                                        <tr><th>Candidate</th><th>gate</th><th>why removed</th></tr>
                                        <tr *ngFor="let d of t.disqualified">
                                            <td>{{ d.name }}</td>
                                            <td><span class="chip rule" *ngIf="d.rule">{{ d.rule }}</span><span *ngIf="!d.rule">—</span></td>
                                            <td>{{ d.reasons.join('; ') }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </ng-container>
                        </li>

                        <!-- 5. Summary agent -->
                        <li class="flow-step">
                            <div class="step-head">
                                <span class="step-num">5</span>
                                <h4>Summary agent · grounded explanations</h4>
                            </div>
                            <p class="step-desc">AI, per candidate. In = profile + JD + tier; out = “Why They Fit” / “Things to Look Into”. Example below (one of {{ pipelineStats.total }}).</p>

                            <button class="io-toggle" (click)="ToggleSection('summary.in')" [attr.aria-expanded]="IsSectionOpen('summary.in')">
                                <span class="caret" [class.open]="IsSectionOpen('summary.in')">&#9656;</span> Input — candidate profile (example)
                            </button>
                            <pre class="io-pre" *ngIf="IsSectionOpen('summary.in') && t.candidates.length > 0">{{ t.candidates[0].summaryProfile }}</pre>

                            <button class="io-toggle" (click)="ToggleSection('summary.out')" [attr.aria-expanded]="IsSectionOpen('summary.out')">
                                <span class="caret" [class.open]="IsSectionOpen('summary.out')">&#9656;</span> Output (example)
                            </button>
                            <div class="io-body" *ngIf="IsSectionOpen('summary.out') && exampleCandidate as ex">
                                <div class="brief-group"><h5>Why They Fit</h5><p class="io-text">{{ ex.whySuggested || 'generating…' }}</p></div>
                                <div class="brief-group"><h5>Things to Look Into</h5><p class="io-text">{{ ex.thingsToLookInto || 'generating…' }}</p></div>
                            </div>
                        </li>
                    </ng-container>
                </ol>
                <button
                    type="button"
                    class="brief-collapse"
                    *ngIf="briefOpen && trace"
                    (click)="CollapseBrief()"
                    [attr.aria-expanded]="briefOpen"
                    aria-label="Collapse matching methodology">
                    <span class="caret-up" aria-hidden="true">&#9652;</span> Close matching methodology
                </button>
            </section>
        </div>

        <div class="grid">
            <maps-result-card
                *ngFor="let c of pagedResults; let i = index; trackBy: TrackByCandidateId"
                [candidate]="c"
                [variantIndex]="i"
                [isSelected]="IsCandidateSelected(c)"
                [contactStatus]="ContactStatusFor(c.candidateId)"
                [summariesFailed]="summariesFailed"
                (summariesRetry)="RetrySummaries()"
                (viewExperience)="OpenExperienceDrawer(c)"
                (contact)="OpenContactModal([c])"
                (selectionChanged)="OnSelectionChanged($event)"></maps-result-card>
            <div *ngIf="rawResults.length === 0" class="no-results">
                <h3>No candidates match this search</h3>
                <p>If you set required qualifications, try moving some to Preferred (or remove them) above, then update results again.</p>
            </div>
            <div *ngIf="rawResults.length > 0 && results.length === 0" class="no-results">
                <h3>No candidates match the current filters</h3>
                <p>Remove or loosen the active filters above to see candidates again.</p>
            </div>
        </div>

        <maps-pagination
            *ngIf="showPagination"
            [currentPage]="safeCurrentPage"
            [totalItems]="results.length"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            (pageChange)="OnPageChange($event)"
            (pageSizeChange)="OnPageSizeChange($event)"></maps-pagination>

        <button
            type="button"
            class="back-to-top"
            *ngIf="results.length > 0"
            (click)="BackToTop()"
            aria-label="Back to top">
            <span class="caret-up" aria-hidden="true">&#9652;</span> Back to top
        </button>
    </section>

    <maps-experience-drawer
        *ngIf="experienceCandidate"
        [candidate]="experienceCandidate"
        [contactStatus]="ContactStatusFor(experienceCandidate.candidateId)"
        [summariesFailed]="summariesFailed"
        (summariesRetry)="RetrySummaries()"
        (contact)="OpenContactModal([experienceCandidate])"
        (closed)="CloseExperienceDrawer()"></maps-experience-drawer>

    <maps-bulk-action-bar
        [selectedCount]="selectedCount"
        [searchId]="searchId"
        [candidateIds]="selectedIdsInOrder"
        [exportCap]="exportCap"
        (contactAll)="OpenContactModalForSelection()"
        (clearSelection)="ClearSelection()"></maps-bulk-action-bar>

    <maps-contact-modal
        *ngIf="contactCandidates"
        [candidates]="contactCandidates"
        [searchId]="searchId"
        [cap]="contactSendCap"
        (sent)="OnContactSent($event)"
        (closed)="CloseContactModal()"></maps-contact-modal>

    <maps-weighting-drawer
        *ngIf="weightingOpen"
        [qualifications]="qualifications"
        [isApplying]="isApplyingWeights"
        [configApplied]="configApplied"
        (apply)="OnApplyWeightsFromDrawer($event)"
        (restore)="OnRestoreWeightsFromDrawer()"
        (closed)="CloseWeightingDrawer()"></maps-weighting-drawer>
</div>
